import Box, { BoxProps } from "ds/components/Box";

const ModuleSettingsFormWrapper = ({ children, gap, ...restProps }: BoxProps) => {
  return (
    <Box
      direction="column"
      gap={gap}
      padding="x-large"
      limitWidth={restProps.fullWidth ? undefined : "medium"}
      {...restProps}
    >
      {children}
    </Box>
  );
};

export default ModuleSettingsFormWrapper;
